import React, { useEffect, useState } from "react";
import {
  PatternlibDropdown,
  PatternlibTextlink,
  PatternlibOption,
} from "@liebherr/patternlib-react";
import PropTypes from "prop-types";
import { v4 as uuidv4 } from "uuid";
import Separator from "../separator/Separator.js";
import { useTranslation } from "react-i18next";
import { checker } from "../../helpers/helpers.js";

const Dropdown = ({
  label,
  placeholder,
  data,
  variable,
  onChange,
  disabled,
  fixed,
  onReset,
  closeOnScroll,
}) => {
  const [value, setValue] = useState({});
  const [options, setOptions] = useState([]);
  const [selected, setSelected] = useState();

  const { t } = useTranslation();

  // Call function, when value has been changed
  useEffect(() => {
    if (Object.keys(value).length >= 1) {
      onChange(value);
    }
  }, [value]);

  const setData = (dataValues, unfiltered, cleared) => {
    if (dataValues !== undefined && dataValues.values) {
      const arr = [];
      let options = dataValues.values;

      if (!unfiltered) {
        options = dataValues.values.filter((item) => item.visible == true);
      }

      options.map((item) => {
        const obj = {
          label: item.name,
          value: item.value,
          selected:
            item.name === data[variable]["resolvedVal"] && !cleared
              ? true
              : false,
        };
        arr.push(obj);
      });

      // Filter array for selected and set state
      const result = arr.filter((el) => el.selected === true);
      if (result.length > 0) {
        setSelected(result[0].value);
      }

      // Set options
      setOptions(arr);
    }
  };

  const createUniqueId = () => {
    const id = uuidv4();
    return id;
  };

  const isFixed = () => {
    if (fixed !== undefined) {
      const arr = fixed["fixed"];
      const key = fixed["fixedKey"];

      if (checker(arr)) {
        return true;
      } else {
        if (key !== undefined) {
          if (
            (variable === "D" && key === "D") ||
            (variable === "SD" && key === "SD")
          ) {
            return false;
          } else {
            return true;
          }
        } else {
          return false;
        }
      }
    }
  };

  const includeKeys = ["D", "SD"];

  const reset = (key) => () => {
    onReset(key);
  };

  // Call function, when data has been changed and set options for dropdown
  useEffect(() => {
    // check if one or more keys should be fixed

    if (variable === "D" || variable === "SD") {
      setData(
        isFixed() ? data["fixed" + variable] : data[variable],
        !isFixed(),
        false
      );
    } else {
      setData(data[variable], false, false);
    }
  }, [data, fixed]);

  const onChangeListener = (event) => {
    if (event.detail.selected?.value !== undefined) {
      const selectedValue = event.detail.selected.value;
      setValue({ variable, value: selectedValue });
    } else {
      // console.log("Dropdown needs to be reset");
      // Data needs to be saved unfiltered during inital render and applied if the dropdown gets reset
      setData(data, true, true);
    }
  };

  return (
    <div>
      <PatternlibDropdown
        label={label}
        placeholder={placeholder}
        onLhSelect={(e) => onChangeListener(e)}
        value={selected}
        disabled={disabled}
        show-remove-icon="false"
        prevent-input
        close-on-scroll={closeOnScroll}
        show-arrow-icon={!disabled}
      >
        {options &&
          options.map((item) => {
            const uniqueId = createUniqueId();
            return (
              <PatternlibOption
                value={item.value}
                key={uniqueId}
                label={item.label}
              ></PatternlibOption>
            );
          })}
      </PatternlibDropdown>
      {isFixed() && includeKeys.includes(variable) && (
        <>
          <Separator space="xxxs"></Separator>
          <PatternlibTextlink
            label={t("Dropdown.reset")}
            size="small"
            onClick={reset(variable)}
          ></PatternlibTextlink>
        </>
      )}
    </div>
  );
};

Dropdown.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  data: PropTypes.any,
  variable: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  fixed: PropTypes.any,
  onReset: PropTypes.func,
  closeOnScroll: PropTypes.bool,
};

Dropdown.defaultProps = {
  label: "Label",
  placeholder: "Placeholder text",
  variable: "",
  disabled: false,
  closeOnScroll: true,
};

export default Dropdown;
